const RECEIVE_ALL_OMNI_COUNTRIES = 'src/omniCountries/RECEIVE_ALL_OMNI_COUNTRIES';

export default { RECEIVE_ALL_OMNI_COUNTRIES };
